import { Message } from 'primereact/message';
import { Panel } from 'primereact/panel';
import { Toast } from 'primereact/toast';
import React, { useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';

import DisputeNeedsReviewPillstatus from '../../assets/DisputeNeedsReviewPillstatus.png';
import DisputeReviewedPillStatus from '../../assets/DisputeReviewedPillStatus.png';
import { CoachingInsight } from '../../components/coachingInsight/CoachingInsight';
import MessageInfo from '../../components/messageInfo/MessageInfo';
import { PillStatus } from '../../components/pillsStatus/PillStatus';
import { ScoreCardDashboardViewTable } from '../../components/scoreCardDashboardTable/ScoreCardDashboardViewTable';
import { MANAGERROLE, SUPERVISORROLE } from '../../constants';
import { ToDoView } from '../../features/coaching/toDoView/ToDoView';
import { useGetCaManagerTlSearchQuery } from '../../features/correctiveActions/managerTlViewSearch/CaMangerTLView.slice';
import AgentScoreCardDashboardTabs from '../../features/scorecardDashboard/agentScoreCardDashboard/AgentScoreCardDashboardTabs';
import { CaDashboardScorecard } from '../../features/scorecardDashboard/caDashboardScorecard/CaDashboardScorecard';
import FilterAgentScoreCard from '../../features/scorecardDashboard/filterAgentSocoreCard/FilterAgentScoreCard';
import { MyCaDashboardScorecard } from '../../features/scorecardDashboard/myDashboardScorecard/MyCaDashboardScorecard';
import TeamLeadPayout from '../../features/scorecardDashboard/teamLeadPayout/TeamLeadPayout';
import TeamLeadScorecardDispute from '../../features/scorecardDashboard/teamLeadScorecardDispute/TeamLeadScorecardDispute';
import TeamPayout from '../../features/scorecardDashboard/teamPayout/TeamPayout';
import { CaStatusNames, ConstApprovalWindowStatus, ConstReviewStatus } from '../../utils/typeConstants';
import { useGetPrimaryApprovalWindowQuery } from '../compensation/compensationSlice';
import {
    selectCurrentRole,
    selectIsDelegate,
    selectIsAllowCoachingInsight,
    selectCurrentUserParentClient,
} from '../login/authSlice';
import './ScorecardDashboard.scss';
import { loadSCfilDate } from '../../utils/dateStorage';
import { useGetTeamLeadScorecardAgentsQuery } from './scorecardDashboardSlice';

export const ScorecardDashboard = () => {
    const toast = useRef<Toast>(null);
    const [date, setDate] = useState(new Date());
    const [inputmonth, setMonth] = useState(new Date().getMonth() + 1);
    const [inputyear, setYear] = useState(new Date().getFullYear());
    const [scorecardVersion, setScorecardVersion] = useState(0);
    const [isSpervisor, setIsSpervisor] = useState(false);
    const [isManager, setIsManager] = useState(false);
    const isDelegate = useSelector<boolean | undefined | null>(selectIsDelegate);
    const loggedRole = useSelector(selectCurrentRole);
    const [scoreCardDisputesData, setScoreCardDisputesData] = useState<any>([]);
    const [empNum, setAgentNumber] = useState<any>();
    const [caMangerTlData, setCaMangerTlData] = useState<any>([]);
    const [caDasbhoardData, setCaDashboardData] = useState<any>([]);
    const isAllowCoachingInsight = useSelector(selectIsAllowCoachingInsight);

    const currentUserParentClient = useSelector(selectCurrentUserParentClient);

    const tlApprovalColumns = [
        { id: 100, filter: true, name: 'Status', field: 'review_status_name', template: 'statusTemplate' },
    ];

    const [teamStatsPillStatusDetails, setTeamStatsPillStatusDetails] = useState({
        status: '',
        icon: '',
        tooltip: '',
        bgColor: '',
    });

    const { data: teamLeadScorecardAgentData } = useGetTeamLeadScorecardAgentsQuery(
        {
            employeenumber: empNum,
            year: inputyear,
            month: inputmonth,
            scorecardVersionId: scorecardVersion,
        },
        { skip: !empNum || !scorecardVersion }
    );

    const { data: primaryApprovalWindowData } = useGetPrimaryApprovalWindowQuery(
        {
            year: inputyear,
            month: inputmonth,
            scorecardVersionId: scorecardVersion,
            approvalWindowConfigLevelId: 3,
        },
        { skip: !inputyear || !inputmonth || !scorecardVersion }
    );

    const { data: caMangerTlDataSlice } = useGetCaManagerTlSearchQuery(
        {
            employeeNumber: empNum,
            isCurrentTeam: true,
            isApprovals: false,
        },
        {
            skip: !empNum,
        }
    );
    const { data: caDashboardDataSlice } = useGetCaManagerTlSearchQuery(
        {
            employeeNumber: empNum,
        },
        {
            skip: !empNum,
        }
    );

    useEffect(() => {
        if (loggedRole === SUPERVISORROLE) {
            setIsSpervisor(true);
        }
        if (loggedRole === MANAGERROLE) {
            setIsManager(true);
        }
    });

    useEffect(() => {
        const storedDate = loadSCfilDate();
        if (storedDate) {
            setDate(storedDate);
            setMonth(storedDate.getMonth() + 1);
            setYear(storedDate.getFullYear());
        }
    }, []);

    useEffect(() => {
        if (caDashboardDataSlice?.data?.length > 0) {
            const filteredCA = caDashboardDataSlice.data.filter(
                (data: any) => data.ca_status_name === CaStatusNames.Release
            );
            setCaDashboardData(filteredCA);
        } else {
            setCaDashboardData([]);
        }
    }, [caDashboardDataSlice]);

    useEffect(() => {
        if (caMangerTlDataSlice?.data?.length > 0) {
            const filteredCA = caMangerTlDataSlice.data.filter(
                (data: any) =>
                    data.ca_status_name !== CaStatusNames.Rejected &&
                    (data.ca_status_name === CaStatusNames.Approved ||
                        data.ca_status_name === CaStatusNames.Rejected)
            );
            setCaMangerTlData(filteredCA);
        } else {
            setCaMangerTlData([]);
        }
    }, [caMangerTlDataSlice]);

    useEffect(() => {
        // primaryApprovalWindowDataValue(primaryApprovalWindowData);
        if (teamLeadScorecardAgentData?.data) {
            const reviewStatusses: number[] = Array.from(
                new Set(teamLeadScorecardAgentData?.data.map((item: any) => item.review_status_id))
            );
            if (primaryApprovalWindowData?.data?.length > 0) {
                if (
                    primaryApprovalWindowData?.data[0]?.approval_window_status_id ===
                    ConstApprovalWindowStatus.ASSOCIATE_WINDOW
                ) {
                    if (
                        reviewStatusses?.length > 0 &&
                        reviewStatusses?.includes(ConstReviewStatus.DISPUTED)
                    ) {
                        setTeamStatsPillStatusDetails({
                            status: 'Disputed',
                            icon: DisputeNeedsReviewPillstatus,
                            tooltip: ' Please resolve agent disputes and review metrics.',
                            bgColor: '',
                        });
                    } else if (
                        reviewStatusses?.length > 0 &&
                        reviewStatusses?.includes(ConstReviewStatus.NEEDS_REVIEW)
                    ) {
                        setTeamStatsPillStatusDetails({
                            status: 'Needs Review',
                            icon: DisputeNeedsReviewPillstatus,
                            tooltip: ' Agent must review metrics.',
                            bgColor: '',
                        });
                    } else {
                        setTeamStatsPillStatusDetails({
                            status: 'Reviewed',
                            bgColor: '#64d96e',
                            icon: DisputeReviewedPillStatus,
                            tooltip: ' All Reviewed.',
                        });
                    }
                } else if (
                    primaryApprovalWindowData?.data[0]?.approval_window_status_id !==
                    ConstApprovalWindowStatus.ASSOCIATE_WINDOW
                ) {
                    if (
                        reviewStatusses?.length > 0 &&
                        reviewStatusses?.includes(ConstReviewStatus.DISPUTED)
                    ) {
                        setTeamStatsPillStatusDetails({
                            status: 'Disputed',
                            icon: DisputeNeedsReviewPillstatus,
                            tooltip: ' Please resolve agent disputes and review metrics.',
                            bgColor: '',
                        });
                    } else if (
                        reviewStatusses?.length > 0 &&
                        reviewStatusses?.includes(ConstReviewStatus.NEEDS_REVIEW)
                    ) {
                        setTeamStatsPillStatusDetails({
                            status: 'Open',
                            bgColor: '#64d96e',
                            icon: '',
                            tooltip: '',
                        });
                    } else {
                        setTeamStatsPillStatusDetails({
                            status: 'Reviewed',
                            bgColor: '#64d96e',
                            icon: DisputeReviewedPillStatus,
                            tooltip: ' Great progress.',
                        });
                    }
                }
            } else setTeamStatsPillStatusDetails({ status: '', tooltip: '', bgColor: '', icon: '' });
        } else setTeamStatsPillStatusDetails({ status: '', tooltip: '', bgColor: '', icon: '' });
    }, [teamLeadScorecardAgentData, primaryApprovalWindowData]);

    return (
        <>
            <Toast ref={toast} position="top-center" />
            {isSpervisor || isManager ? (
                <div>
                    <FilterAgentScoreCard
                        scorecardVersionValue={setScorecardVersion}
                        setAgentNumber={setAgentNumber}
                        inputmonth={inputmonth}
                        setInputMonth={setMonth}
                        inputyear={inputyear}
                        setInputYear={setYear}
                        date={date}
                        setDate={setDate}
                    />
                    <div style={{ padding: '0.5rem' }} className='card shadow bg-body rounded mt-3 border-0'>
                    <AgentScoreCardDashboardTabs
                        key={`${empNum}-${inputyear}-${inputmonth}-${scorecardVersion}`}
                        empNum={empNum}
                        inputmonth={inputmonth}
                        inputyear={inputyear}
                        scorecardVersion={scorecardVersion}
                    />
                    </div>
                </div>
            ) : (
                <div className="card mt-4 ms-4 me-4 shadow bg-body rounded">
                    <div className="card-body p-0 pe-5 ps-4 align-middle text-center">
                        <div className="row" style={{ height: '75vh' }}>
                            <div className="col-md-12" style={{ margin: 'auto' }}>
                                <Message severity="warn" text="Not a Supervisor Role" />
                            </div>
                        </div>
                    </div>
                </div>
            )}

            <Panel
                headerTemplate={(options) =>
                    PillStatus({
                        options,
                        Headertext: 'Team Stats',
                        pillDetails: teamStatsPillStatusDetails,
                    })
                }
                toggleable
                collapsed
                className="approvalPanel card mt-4 shadow bg-body rounded border-0"
            >
                {teamLeadScorecardAgentData?.data.length > 0 ? (
                    <div className="row mt-4">
                        <div className="col-12">
                            <div className="card shadow bg-body rounded border-0">
                                <div className="card-body">
                                    <ScoreCardDashboardViewTable
                                        enableNavigateAgent
                                        ScoreCardAgentdata={teamLeadScorecardAgentData}
                                        inputMonth={inputmonth}
                                        inputYear={inputyear}
                                        supervisorNumber={empNum}
                                        scorecardVersion={scorecardVersion}
                                        TLApprovalColumns={tlApprovalColumns}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                ) : (
                    <MessageInfo
                        title="No results found."
                        message="Try adjusting the month or scorecard filter above."
                        rowHeight="200px"
                    />
                )}
            </Panel>

            {isAllowCoachingInsight === true && (
                <Panel
                    header="Call Insight"
                    toggleable
                    collapsed
                    className="approvalPanel card mt-4 shadow bg-body rounded border-0"
                >
                    <CoachingInsight selectedParentClient={currentUserParentClient}/>
                </Panel>
            )}
            {/* Team Payout */}
            <TeamPayout
                empNum={empNum}
                primaryApprovalWindowData={primaryApprovalWindowData}
                inputmonth={inputmonth}
                inputyear={inputyear}
                scorecardVersion={scorecardVersion}
            />

            {/* My Payout */}
            <TeamLeadPayout
                empNum={empNum}
                scoreCardDisputesDataValue={scoreCardDisputesData}
                primaryApprovalWindowData={primaryApprovalWindowData}
                scorecardVersion={scorecardVersion}
                inputmonth={inputmonth}
                inputyear={inputyear}
            />

            {/* Scorecard Dispute */}
            <TeamLeadScorecardDispute
                scorecardVersion={scorecardVersion}
                inputmonth={inputmonth}
                inputyear={inputyear}
                scoreCardDisputesDataValue={setScoreCardDisputesData}
            />
            {
                <Panel
                    header="ToDo"
                    toggleable
                    collapsed
                    className="approvalPanel card mt-4 shadow bg-body rounded border-0"
                >
                    <ToDoView />
                </Panel>
            }
            {!isDelegate ? (
                <Panel
                    header={
                        <div>
                            <span>My Team&apos;s Corrective Actions</span>{' '}
                            {caMangerTlData.length > 0 && <span className="needs-action">Needs action</span>}
                        </div>
                    }
                    toggleable
                    collapsed
                    className="approvalPanel card mt-4 shadow bg-body rounded border-0"
                >
                    <CaDashboardScorecard caData={caMangerTlData} />
                </Panel>
            ) : null}
            {!isDelegate ? (
                <Panel
                    header={
                        <div>
                            <span>My Corrective Actions</span>{' '}
                            {caDasbhoardData.length > 0 && <span className="needs-action">Needs action</span>}
                        </div>
                    }
                    toggleable
                    collapsed
                    className="approvalPanel card mt-4 shadow bg-body rounded border-0"
                >
                    <MyCaDashboardScorecard />
                </Panel>
            ) : null}
        </>
    );
};
